import { Fade } from '@mui/material';

interface EmptyStateProps {
  message: string;
}

const EmptyState = ({ message }: EmptyStateProps) => {
  return (
    <Fade in={true} timeout={600}>
      <div className='flex flex-col items-center justify-center py-20 px-8 border border-dashed border-gray-100 rounded-2xl bg-gray-50/50'>
        <span className='text-gray-400 font-bold text-base text-center'>
          {message}
        </span>
      </div>
    </Fade>
  );
};

export default EmptyState;
